import { lazy } from 'react';
import { authRoles } from 'app/auth';

const DataAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.warehouseMan,
	routes: [
		{
			path: '/apps/warehouse-history',
			component: lazy(() => import('./list/Datas'))
		}
	]
};

export default DataAppConfig;
